import EventEmitter from "./EventEmitter";
export default class AboutPage extends EventEmitter {
  constructor() {
    super();
    this.page = document.querySelector("#aboutPage");
    this.button = this.page.querySelector(".basicButton");
    this.links = this.page.querySelectorAll("a");
    this.initListeners();
  }
  initListeners() {
    this.links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        // console.log(e.target.href);
        this.emit("click", [e.target.href]);
      });
    });
    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      //   this.emit("click", ["close"]);
      this.hide();
    });
  }

  show() {
    this.page.classList.add("zoomIn");
    this.page.classList.remove("hidden");
  }
  hide() {
    this.page.classList.remove("zoomIn");
    this.page.classList.add("zoomOut");
    setTimeout(() => {
      this.page.classList.add("hidden");
      this.page.classList.remove("zoomOut");
    }, 1000);
  }
}
